import { useEffect } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { SarlaftDeclarationProps } from './props';
import { SarlaftDeclaration } from '../../../../../../shared/types/modules/sarlaft';

export const useSarlaftDeclaration = ({
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftDeclarationProps) => {
    const onSubmit = (data: SarlaftDeclaration) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue(
            'lastYearTaxReturn',
            data?.lastYearTaxReturn || ''
        );
    }, [data]);

    return {
        formik,
    };
};
